export const TagType = {
  Include: 'include',
  Exclude: 'exclude'
} as const;

export type TagTypeType = (typeof TagType)[keyof typeof TagType];
